module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Medium.751cdac5.otf";